import { blockDaysApi as generatedBlockDaysApi } from '../generated/slots/blockDays';

const blockDaysApi = generatedBlockDaysApi.enhanceEndpoints({
  endpoints: {
    blockDays: {
      invalidatesTags: (result) => [
        { id: 'UPCOMING', type: 'UpcomingAll' as const },
        { id: 'UPCOMING', type: 'UpcomingAppointment' as const },
        { id: 'UPCOMING', type: 'UpcomingDraft' as const },
        { type: 'Schedule' as const },
        { type: 'ScheduleAroundToday' as const },
        ...(result?.updated.map(({ date }) => ({ id: date, type: 'Slots' as const })) ?? []),
      ],
    },
  },
});

export const { useBlockDaysMutation } = blockDaysApi;
